(window._iconfont_svg_string_3909386 =
  '<svg><symbol id="icon-rongqi" viewBox="0 0 1024 1024"><path d="M815.157895 107.789474h-14.44379v808.421052h11.533474C869.429895 916.210526 916.210526 869.429895 916.210526 812.247579V223.285895C916.210526 159.744 871.154526 107.789474 815.157895 107.789474zM208.842105 107.789474C152.791579 107.789474 107.789474 159.744 107.789474 223.285895v57.721263h43.331368a43.654737 43.654737 0 0 1 43.277474 43.331368 43.654737 43.654737 0 0 1-43.277474 43.277474H107.789474V454.332632h43.331368a43.654737 43.654737 0 0 1 43.277474 43.277473 43.654737 43.654737 0 0 1-43.277474 43.331369H107.789474v86.608842h43.331368a43.654737 43.654737 0 0 1 43.277474 43.277473 43.654737 43.654737 0 0 1-43.277474 43.331369H107.789474v86.608842C107.789474 864.256 152.845474 916.210526 208.842105 916.210526h534.096842V107.789474h-534.096842z m325.685895 361.472c15.629474 0 27.701895 5.766737 31.797895 19.078737 2.856421 10.940632-2.910316 20.210526-15.090527 25.384421a54.810947 54.810947 0 0 1-21.935157 3.449263H460.045474v41.606737h79.656421c16.761263 0 26.570105 8.084211 29.480421 20.803368 2.317474 12.665263-8.084211 23.066947-24.845474 25.977263-6.359579 1.131789-12.719158 1.131789-18.485895 1.13179H458.859789v58.314105c-1.131789 16.761263-12.665263 26.570105-30.61221 26.570105-16.707368 0-27.701895-9.808842-28.294737-26.570105-0.538947-19.024842 0-38.103579 0-58.906947H338.189474c-7.545263 0-15.036632 0-22.528-1.724632-16.707368-2.856421-24.791579-12.126316-23.066948-24.791579 1.724632-13.312 12.665263-20.803368 29.426527-20.803368h76.207158v-41.606737H331.237053c-8.084211 0-16.707368-0.538947-23.65979-2.856421-12.719158-4.634947-18.485895-13.312-16.168421-24.791579 2.910316-12.773053 13.312-19.078737 28.887579-19.671579 24.252632-0.538947 49.044211 0 73.296842 0l4.096-4.042105c-6.359579-4.042105-13.312-8.084211-19.671579-12.719158-26.570105-21.342316-53.679158-42.145684-80.249263-63.488-15.629474-12.719158-17.300211-26.570105-4.042105-36.97179 12.719158-10.401684 30.019368-8.623158 46.187789 3.449263 28.887579 23.120842 57.775158 46.187789 89.465263 72.218948 17.946947-15.629474 35.247158-30.073263 52.008421-43.924211l34.654316-27.701895c14.443789-10.994526 32.875789-10.994526 45.056-0.538947 11.533474 9.754947 10.940632 23.066947-3.503158 34.600421-27.109053 21.935158-54.810947 43.870316-82.566736 65.805474l-15.575579 13.312h74.482526l0.538947-0.538948z"  ></path></symbol></svg>'),
  (n => {
    var t = (e = (e = document.getElementsByTagName("script"))[
        e.length - 1
      ]).getAttribute("data-injectcss"),
      e = e.getAttribute("data-disable-injectsvg");
    if (!e) {
      var o,
        i,
        c,
        d,
        a,
        s = function (t, e) {
          e.parentNode.insertBefore(t, e);
        };
      if (t && !n.__iconfont__svg__cssinject__) {
        n.__iconfont__svg__cssinject__ = !0;
        try {
          document.write(
            "<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>"
          );
        } catch (t) {
          console?.log(t);
        }
      }
      (o = function () {
        var t,
          e = document.createElement("div");
        (e.innerHTML = n._iconfont_svg_string_3909386),
          (e = e.getElementsByTagName("svg")[0]) &&
            (e.setAttribute("aria-hidden", "true"),
            (e.style.position = "absolute"),
            (e.style.width = 0),
            (e.style.height = 0),
            (e.style.overflow = "hidden"),
            (e = e),
            (t = document.body).firstChild
              ? s(e, t.firstChild)
              : t.appendChild(e));
      }),
        document.addEventListener
          ? ~["complete", "loaded", "interactive"].indexOf(document.readyState)
            ? setTimeout(o, 0)
            : ((i = function () {
                document.removeEventListener("DOMContentLoaded", i, !1), o();
              }),
              document.addEventListener("DOMContentLoaded", i, !1))
          : document.attachEvent &&
            ((c = o),
            (d = n.document),
            (a = !1),
            r(),
            (d.onreadystatechange = function () {
              "complete" == d.readyState &&
                ((d.onreadystatechange = null), l());
            }));
    }
    function l() {
      a || ((a = !0), c());
    }
    function r() {
      try {
        d.documentElement.doScroll("left");
      } catch (t) {
        return void setTimeout(r, 50);
      }
      l();
    }
  })(window);
